"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.register = register;

var _react = _interopRequireDefault(require("react"));

var _addons = _interopRequireDefault(require("@storybook/addons"));

var _ActionLogger = _interopRequireDefault(require("./containers/ActionLogger"));

var _ = require(".");

function register() {
  _addons.default.register(_.ADDON_ID, function (api) {
    var channel = _addons.default.getChannel();

    _addons.default.addPanel(_.PANEL_ID, {
      title: 'Action Logger',
      // eslint-disable-next-line react/prop-types
      render: function render(_ref) {
        var active = _ref.active;
        return _react.default.createElement(_ActionLogger.default, {
          channel: channel,
          api: api,
          active: active
        });
      }
    });
  });
}